<template>
    <v-layout :id="'trainingModule' + this.module.id" class="fill-height training-module-component" :class="machineName">
        <v-flex xs12 class="mb-5">
            <v-layout class='pa-0 yellow-shade' height="500" tag="section">
                <v-flex class="ma-2">
                    <v-layout row wrap align-start justify-start>
                        <div
                         class="wrap-icon-card py-2 pl-3 pr-2"
                         :class="{'mx-2 my-3 full-w-card': $vuetify.breakpoint.smAndDown, 'mx-4 my-5 ': $vuetify.breakpoint.mdAndUp}"
                        >
                            <v-card :width="modImgWidth" class="module-icon-card pa-0" color="white">
                                <v-responsive height="270" >
                                    <v-container class='module-card-content fill-height pa-0'>
                                        <div class="module-card-image"></div>
                                    </v-container>
                                </v-responsive>
                            </v-card>
                        </div>
                        <v-flex xs12 sm12 md5 offset-md-1
                            :class="{'my-3': $vuetify.breakpoint.smAndDown, 'my-5': $vuetify.breakpoint.mdAndUp}"
                        >
                            <v-card  flat class="px-3 transparent">
                                <v-card-title class="pb-0" v-if="module.subtitle">
                                    <h2 class="title secondaryDark--text text-uppercase">{{ module.subtitle }}</h2>
                                </v-card-title>
                                <v-card-title class="pt-0">
                                    <h3>{{ module.title }}</h3>
                                </v-card-title>
                                <v-card-text class='text-xs-left' v-html="module.description"></v-card-text>
                            </v-card>
                        </v-flex>
                        <!-- <v-flex xs12 md3 lg2 xl2
                            class='yellow-shade px-4 text-xs-left'
                            :class="{'mt-3 mb-5': $vuetify.breakpoint.smAndDown, 'my-5': $vuetify.breakpoint.mdAndUp}"
                        >
                            <v-card class="px-3 pt-2 pb-3">
                              <v-card-text class="module-resources d-inline-flex align-center pl-0">
                                  <v-icon large color="amber" class="shrink">folder</v-icon>
                                  <h4 class="resources-text ml-1">Module Resources</h4>
                              </v-card-text>
                              <router-link to="/module/1">View additional resources for this module ></router-link>
                            </v-card>
                        </v-flex> -->
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout>
                <ModuleSteps :module="module" :key="module.id"></ModuleSteps>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<style scoped lang='scss'>
.full-w-card {
    width: 100%;
}
.module-icon-card {
    .module-card-content {
      .module-card-image {
        background: url(~@/assets/icons/ruler_pencil_paper.svg) no-repeat;
        height: 100%;
        width: 100%;
        background-position: top left;
        background-size: contain;
      }
      .module-name {
          font-size: 18px;
      }
    }
}
.module-resources > * {
    flex: 0 1 auto !important;
}
</style>

<script>
import TrainingModuleService from "@/services/TrainingModuleService"
import ModuleSteps from "./Steps"
import { EventBus } from "@/components/Events/event-bus";

export default {
  components: { ModuleSteps },
  data() {
    return {
      loading: false,
      offsetTop: 0,
      module: {
        id: null,
        name: '',
        title: '',
        description: '',
        steps: [],
        user: null,
        date: null
      }
    }
  },
  computed: {
    // Create a machine name (no spaces, alphanumeric only) module identifier
    machineName() {
      // Based on https://github.com/mrded/machine-name/blob/master/index.js.
      return 'module-' + this.module.name.replace(/[^A-Za-z0-9 ]/g, '').replace(/\s{2,}/g, ' ').replace(/\s/g, "-").toLowerCase();
    },
    modImgWidth() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return '250px';
      } else {
        return '100%';
      }
    }
  },
  methods: {
    setupPage(id) {
      TrainingModuleService.getModule(id)
        .then(res => {
          this.$set(this, 'module', res);
          this.module.id = id;
        }, err => {
          this.$router.push({ path: '/dashboard' })
        })
        .finally(res => {
          this.$store.commit("loading", { loading: false })
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.$store.state.loading) {
        vm.$store.commit("loading", { loading: true });
        vm.setupPage(to.params.id);
      }
    });
  },
  created() {
    this.$store.commit("loading", { loading: true });
    this.setupPage(this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.commit("loading", { loading: true });
    this.setupPage(to.params.id);
    next();
  },
  beforeDestroy() {
    EventBus.$off('refresh-module');
  }
}
</script>
